import { DropDown } from '@grays-npm/component-library';
import { useState, useEffect } from 'react';
import {
  activeSortOptions,
  pendingSortOptions,
  soldSortOptions,
  universalSortOptions,
  unsoldSortOptions,
} from './data';

export enum ListingsTabs {
  Pending = 'Pending',
  Active = 'Active',
  Sold = 'Sold',
  Unsold = 'Unsold',
  AssetForSale = 'AssetForSale',
  Referred = 'Referred',
}

export type ListingsTab = keyof typeof ListingsTabs;

type SortListingsProps = {
  tab?: ListingsTab;
  onSelect: (value: string) => void;
};

export const SortListings: React.FC<SortListingsProps> = ({
  tab = ListingsTabs.Active,
  onSelect,
}) => {
  const [selectedValue, setSelectedValue] = useState('');
  const [options, setOptions] = useState(universalSortOptions);
  const handleSort = (value: string) => {
    setSelectedValue(value);
    onSelect(value);
  };

  useEffect(() => {
    let tempOptions = universalSortOptions;
    let initValue = '';
    switch (tab) {
      case ListingsTabs.Pending:
        tempOptions = pendingSortOptions;
        initValue = 'StartingSoonest';
        break;
      case ListingsTabs.Sold:
        tempOptions = soldSortOptions;
        initValue = 'RecentlySold';
        break;
      case ListingsTabs.Active:
        tempOptions = activeSortOptions;
        initValue = 'EndingSoonest';
        break;
      case ListingsTabs.Unsold:
        tempOptions = unsoldSortOptions;
        initValue = 'RecentlyClosed';
        break;
      default:
        tempOptions = universalSortOptions;
        initValue = tempOptions[0].value || 'ReserveHightoLow';
        break;
    }
    setOptions(tempOptions);
    setSelectedValue(initValue);
  }, [tab]);

  return (
    <DropDown
      align="right"
      label="Sort"
      onChange={handleSort}
      options={options}
      selectedValue={selectedValue}
    />
  );
};
